// extracted by mini-css-extract-plugin
export var container = "FeaturedAuction-module--container--o0JbA";
export var cover = "FeaturedAuction-module--cover--gkpC7";
export var endDate = "FeaturedAuction-module--endDate--HjJbf";
export var header = "FeaturedAuction-module--header--F3hIH";
export var saleContainer = "FeaturedAuction-module--saleContainer--Uzd6B";
export var spacer = "FeaturedAuction-module--spacer--Vbwp6";
export var subheader = "FeaturedAuction-module--subheader--JZoFX";